/**
 * SearchPatient Component
 * Searchable dropdown for patient selection
 */

import React, { useState } from "react";
import { useClickOutside } from "../hooks/useClickOutside";

const SearchPatient = ({
  patientOptions,
  onSelectPatient,
  required = false,
}) => {
  const [searchPatient, setSearchPatient] = useState("");
  const [showPatientDropdown, setShowPatientDropdown] = useState(false);

  // Close dropdown when clicking outside
  useClickOutside(".search-patient-wrapper", () => {
    setShowPatientDropdown(false);
  });

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchPatient(value);
    setShowPatientDropdown(true);

    // Reset selection if search is cleared
    if (value === "") {
      onSelectPatient(null);
    }
  };

  const handleSelectPatient = (patient) => {
    setSearchPatient(patient.displayName);
    setShowPatientDropdown(false);
    onSelectPatient(patient);
  };

  // Filter patients based on search
  const filteredPatients = patientOptions.filter((p) =>
    p.displayName.toLowerCase().includes(searchPatient.toLowerCase())
  );

  return (
    <div className="form-group">
      <label>Nama Pasien: {required && "*"}</label>
      <div className="search-patient-wrapper">
        <input
          type="text"
          className="search-patient-input"
          placeholder="Ketik untuk mencari nama pasien..."
          value={searchPatient}
          onChange={handleSearchChange}
          onFocus={() => setShowPatientDropdown(true)}
          required={required}
          autoComplete="off"
        />
        {showPatientDropdown && searchPatient && (
          <div className="patient-dropdown">
            {filteredPatients.length > 0 ? (
              filteredPatients.map((p) => (
                <div
                  key={p.id}
                  className="patient-option"
                  onClick={() => handleSelectPatient(p)}
                >
                  {p.displayName}
                </div>
              ))
            ) : (
              <div className="patient-option no-result">
                Tidak ada pasien ditemukan
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPatient;
